import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ResourceItem from './ResourceItem'

const ResourcesContainer = styled.ul`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex-flow: row wrap;
  margin: 0;
  padding-bottom: 20px;
  align-items: flex-start;
  width: 600px;

  li:nth-child(4n-1),
  li:nth-child(4n-2) {
    .header {
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
        #fff center top / 100% no-repeat;
    }
  }

  li:nth-child(4n-3),
  li:nth-child(4n-4) {
    .header {
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
        #bbb center top / 100% no-repeat;
    }
  }
`

const ResourcesList = props => {
  const resources = props.resources.map(r => {
    const isClickable = Boolean(r.url || r.file_url)
    return (
      <ResourceItem
        key={r.id}
        resource={r}
        activity={props.activity}
        handleResourceClick={props.handleResourceClick}
        isClickable={isClickable}
      />
    )
  })

  return <ResourcesContainer>{resources}</ResourcesContainer>
}

ResourcesList.propTypes = {
  resources: PropTypes.array.isRequired,
  handleResourceClick: PropTypes.func.isRequired,
  activity: PropTypes.object.isRequired
}

export default ResourcesList



// WEBPACK FOOTER //
// ./src/components/quest/activity/resources/ResourcesList.js